// extracted by mini-css-extract-plugin
export default {"rating":"Kz-z","numberOfStars":"Lz-z","count":"Mz-z","barGraphSpacing":"Nz-z","barGraph":"Oz-z"};